export default __webpack_public_path__ + "static/demandshore-310dee2635f3bdde32c3daba5ab5f176.svg";